


































import Vue from 'vue'

export type Datatype = {
  playerName: string,
}

export default Vue.extend({
  name: 'CardRoomPlayerName',
  
  data(): Datatype {
    return {
      playerName: '',
    }
  },

  methods: {
    setPlayerName(): void {
      this.$emit('setPlayerName', this.playerName)
    },

    cancel() {
      this.$emit('cancel')
    }
  }    
})
